module.exports = __webpack_public_path__ + "img/icon_monthlyPass.43f769fc.png";